<script>
export default {
  props: {
    label: String,
    content: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<template>
  <div class="flex align-end gap-xs">
    <div class="label">{{ label }}</div>
    <div class="text-right">
      <slot v-if="$slots.default" name="default" />
      <div v-else>{{ content || '' }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.label {
  color: var(--color-text-3);
  font-size: 12px;

  &::after {
    content: '：';
  }
}
</style>